<template>
        <div class="loginBox">
            <svg style="position: absolute; width: 0; height: 0;" width="0" height="0" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                <defs>
                    <symbol id="i_email" viewBox="0 0 409.602 307.199">
                        <path d="M358.398,0H51.199C22.926,0,0,22.926,0,51.199V256c0,28.273,22.926,51.199,51.199,51.199h307.199
		c28.278,0,51.204-22.926,51.204-51.199V51.199C409.602,22.926,386.676,0,358.398,0L358.398,0z M274.125,136.625L382.5,43.75
		c0.75,2.398,1.5,4.801,1.5,7.449V256c0,1.773-0.676,3.352-1.023,5.023L274.125,136.625z M358.398,25.602
		c1.704,0,3.204,0.648,4.801,0.972L204.801,162.352L46.398,26.574C48,26.25,49.5,25.602,51.199,25.602H358.398z M26.613,261
		c-0.351-1.676-1.011-3.227-1.011-5V51.199c0-2.648,0.761-5.051,1.511-7.449l108.336,92.852L26.613,261z M51.199,281.602
		c-2.586,0-4.937-0.754-7.301-1.477l111-126.852l41.579,35.625c2.386,2.079,5.359,3.102,8.324,3.102
		c2.961,0,5.937-1.023,8.324-3.102l41.574-35.625l111,126.852c-2.347,0.727-4.699,1.477-7.301,1.477H51.199z M51.199,281.602"/>
                    </symbol>
                    <symbol id="i_send"  viewBox="0 0 512 232.1">
                        <path d="M501.8,0H171.3c-5.6,0-10.2,4.6-10.2,10.2v19.2H63.9c-5.6,0-10.2,4.6-10.2,10.2c0,5.6,4.6,10.2,10.2,10.2h97.2v132.5H103
				c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2h58.1v19.2c0,5.6,4.6,10.2,10.2,10.2h330.5c5.6,0,10.2-4.6,10.2-10.2V10.2
				C512,4.6,507.4,0,501.8,0z M476.6,20.4l-140.1,115l-139.4-115H476.6z M491.6,211.7H181.5V33.9l148.6,122.5
				c1.9,1.6,4.2,2.3,6.5,2.3c2.3,0,4.6-0.8,6.5-2.3l148.6-122V211.7z"/>
                        <path d="M119.7,104.8H10.2C4.6,104.8,0,109.4,0,115c0,5.6,4.6,10.2,10.2,10.2h109.5c5.6,0,10.2-4.6,10.2-10.2
				C129.9,109.4,125.3,104.8,119.7,104.8z"/>
                        <path d="M69.4,182.3h-5.5c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2h5.5c5.6,0,10.2-4.6,10.2-10.2S75,182.3,69.4,182.3z"/>
                    </symbol>
                </defs>
            </svg>

            <img class="logoWrap" src="/static/images/logo.png" alt="seatup">
            <div  v-bind:class="formSubmitted ? 'innerLoginBox formSubmitted' : 'innerLoginBox'">
                <h1>{{ $t('forgottenPass') }}</h1>
                <form action="#" id="forgotPassForm" method="post" @submit.prevent="submitReset">

                    <div class="inputWrap" v-if="token == ''">
                        <label for="loginEmail">
                            <svg class="i_email"><use xlink:href="#i_email"></use></svg>
                            <span>{{ $t('email') }}</span>
                        </label>
                        <input type="email" id="loginEmail" name="loginEmail" v-model="email" required>
                    </div>

                    <div class="inputWrap" v-if="token != ''">
                        <label for="newPass">{{ $t('newPassword') }}</label>
                        <password :badge="false" :secureLength="6" :required="true" :placeholder="null" id="newPass" name="newPass" v-model="newPass"></password>
                    </div>

                    <div class="inputWrap" v-if="token != ''">
                        <label for="verifyNewPass">{{ $t('verifyNewPass') }}</label>
                        <password :badge="false" :secureLength="6" :required="true" :placeholder="null" id="verifyNewPass" name="verifyNewPass" v-model="verifyNewPass"></password>
                    </div>

                    <div class="inputWrap submitWrap">
                        <button>
                            <span>{{ $t('resetMyPass') }}</span>
                        </button>
                    </div>

                    <router-link to="/login" class="loginBtn">{{ $t('goToLogin') }}</router-link>
                </form>
                <div class="confirmResetPass">
                    <svg class="i_send"><use xlink:href="#i_send"></use></svg>
                    <div class="fp_header">אל דאגה!</div>
                    <div class="fp_txt">ברגעים אלה ממש,<br>נשלח אלייך מייל עם הסיסמא החדשה שלך</div>
                    <div class="fp_txt2">בהצלחה!</div>
                </div>
            </div>
        </div>
</template>

<script>
    import Password from 'vue-password-strength-meter'
    export default {
        name: 'PasswordRecovery',

        data() {
            return {
                email: '',
                newPass: '',
                verifyNewPass: '',
                token:'',
                formSubmitted:false
            }
        },

        components:{
            Password
        },

        methods: {
            submitReset(e){
                this.$store.dispatch('resetPassword',this.$data)
                    .then(response =>{
                        switch(response.status){
                            case true:
                                if(this.token != '') {
                                    this.$swal('מעולה!', 'הסיסמא שלך עודנה', 'success').catch(this.$swal.noop);
                                    this.$router.push('/login');
                                    this.isRecovery = this.recoveryToken = false;
                                }else{
                                    this.formSubmitted=true;
                                }
                                break;

                            case false:
                                if(this.recoveryToken != ''){
                                    switch(response.code){
                                        case Errors.CODE_MISSING_PARAMS:
                                            this.$swal('אופס...', 'קרתה תקלה, שננסה שוב?', 'error').catch(this.$swal.noop);
                                            break;

                                        case Errors.CODE_NOT_FOUND:
                                            this.$swal('אופס...', 'פג תוקף אישור איפוס הסיסמא, יש לבצע את הפעולה שוב', 'error').catch(this.$swal.noop);
                                            this.$router.push('/login/recover');
                                            break;
                                    }
                                }else{
                                    switch(response.code){
                                        case Errors.CODE_MISSING_PARAMS:
                                            this.$swal('אופס...', 'כתובת הדואK אינה יכולה להיות ריקה', 'error').catch(this.$swal.noop);
                                            break;

                                        case Errors.CODE_NOT_FOUND:
                                            this.$swal('אופס...', 'לא מצאנו משתמש עם כתובת הדוא"ל הזו', 'error').catch(this.$swal.noop);
                                            break;
                                    }
                                }
                                break;
                        }
                    })
                    .catch(err => {
                        this.$swal('אופס...', 'קרתה תקלה, שננסה שוב?', 'error').catch(this.$swal.noop);
                    });
            }
        },

        beforeMount(){
            if(typeof this.$router.currentRoute.params.token !=='undefined' && this.$router.currentRoute.params.token != ''){
                this.token = this.$router.currentRoute.params.token;
            }

            //check if token is valid
            if(this.token != '') {
                this.$store.dispatch('checkResetToken', this.token)
                    .then(response => {
                        //success
                        if (!response) {
                            this.$swal('Oops...', 'The request token is outdated, make a fresh start', 'error').catch(this.$swal.noop);
                            this.token = '';
                        }
                    })
                    .catch(err => {
                        //err
                        this.$swal('Oops...', 'The request token is outdated, make a fresh start', 'error').catch(this.$swal.noop);
                        this.$router.push('/login');
                        this.token = '';
                    })
            }
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    /*body{
        min-height:calc(100% + 140px)
    }*/
    main{
        background:url('/static/images/loginBg.jpg') center center no-repeat;
        width: 100%;
        min-height: 100%;
        padding:70px;
        position: relative;
    }
    main:before{
        content:"";
        position: absolute;
        top:0;
        right:0;
        width:100%;
        height:100%;
        background: -moz-linear-gradient(0deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%); /* ff3.6+ */
        background: -webkit-gradient(linear, left top, right top, color-stop(0%, rgba(41,59,90,0.95)), color-stop(100%, rgba(123,150,196,0.95))); /* safari4+,chrome */
        background: -webkit-linear-gradient(0deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%); /* safari5.1+,chrome10+ */
        background: -o-linear-gradient(0deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%); /* opera 11.10+ */
        background: -ms-linear-gradient(0deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%); /* ie10+ */
        background: linear-gradient(90deg, rgba(41,59,90,0.95) 0%, rgba(123,150,196,0.95) 100%); /* w3c */
        filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#293b5a', endColorstr='#7b96c4',GradientType=1 ); /* ie6-9 */
    }
    .loginBox{
        text-align: center;
        max-width: 100%;
        position: absolute;
        top: 50%;
        right: 50%;
        transform: translate(50%,-50%);
    }
    .loginBox .logoWrap{
        width:162px;
        margin-bottom:52px;
    }
    .innerLoginBox{
        width:533px;
        max-width:100%;
        padding:70px 110px;
        margin:0 auto;
        background: rgba(41,59,90,0.85);
        position: relative;
    }

    .innerLoginBox h1{
        font-weight:300;
        color:#fff;
        font-size:2.235rem;
        line-height: 2.235rem;
    }
    .innerLoginBox form{
        margin-top:70px;

    }
    .innerLoginBox form svg.i_email{
        fill:#fff;
        width:18px;
        height:14px;
    }
    .innerLoginBox form svg.i_lock{
        fill:#fff;
        width:15px;
        height:23px;
    }
    .loginBtn{
        display:inline-block;
        color:#fff;
        font-size:1rem;
        text-decoration: underline;
        margin-top:30px;

    }
    .loginBtn:hover,
    .loginBtn:focus{
        color:#fff;
    }
    .confirmResetPass{
        position: absolute;
        top:0;
        right:0;
        width:100%;
        height:100%;
        opacity:0;
        z-index: -1;
        color:#fff;
        padding: 70px;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;
    }
    .confirmResetPass svg.i_send{
        width:92px;
        height:42px;
        fill:#57e1d4;
        margin-bottom: 30px;
        margin-right:30px;
    }
    .fp_header{
        font-size:2.353rem;
        margin-bottom: 30px;
    }
    .fp_txt{
        font-size:1.294rem;
        color:#cdcdcd;
        margin-bottom: 30px;
    }
    .fp_txt2{
        font-weight:700;
        font-size:1.294rem;
    }
    .formSubmitted .confirmResetPass{
        opacity:1;
        z-index: 1;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;
    }
    label{
        color: #fff;
    }
    .formSubmitted h1,
    .formSubmitted #forgotPassForm{
        opacity:0;
        transition: opacity .4s ease-in-out;
        -moz-transition: opacity .4s ease-in-out;
        -webkit-transition: opacity .4s ease-in-out;

    }
    @media only screen and (max-width:767px){
        .innerLoginBox{padding:50px 70px;}
        .confirmResetPass{padding:50px;}
        body {min-height: 100%;}
        main{padding:50px 70px;}
        .loginBox{max-width:70%;}
        .loginBox .logoWrap{width: 150px;margin-bottom: 40px;}
        .innerLoginBox form{margin-top: 55px;}
    }
    @media only screen and (max-width:599px){

        .loginBox .logoWrap{width:135px;}
        .innerLoginBox, .confirmResetPass{padding:40px 50px;}
        .innerLoginBox h1{font-size: 2.1rem;line-height: 2.1rem;}
        .innerLoginBox form{margin-top: 45px;}


    }
    @media only screen and (max-width:479px){
        main{padding:50px;}
        .loginBox{max-width:85%;}
        main{padding:0;}
        .innerLoginBox, .confirmResetPass{padding: 40px 20px;}
        .innerLoginBox h1{font-size: 1.8rem;line-height: 1.8rem;}
        .loginBox .logoWrap{width:120px;}
        .innerLoginBox form{margin-top: 25px;}
        .confirmResetPass svg.i_send{width: 75px;height: 35px;margin-bottom: 20px;}
        .fp_header{margin-bottom:20px;}
    }
    @media only screen and (max-width:360px) and (max-height:500px){
        body.loginWrap{min-height: calc(100% + 100px);}
    }
    @media only screen and (max-height:750px){
        .innerLoginBox{padding: 30px 75px;width: 440px;}
        .innerLoginBox form{margin-top: 40px;}
        .loginBox .logoWrap{width: 140px;margin-bottom: 30px;}
        .confirmResetPass{padding:45px;}
    }
    @media only screen and (max-width:599px) and (max-height:750px){
        .innerLoginBox, .confirmResetPass{padding: 30px 50px;}
    }
    @media only screen and (max-width:479px) and (max-height:750px){
        .innerLoginBox, .confirmResetPass{padding: 30px 20px;}
        .loginBox .logoWrap{    width: 120px;}
    }
    input{
        direction: ltr;
    }
</style>